

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.DdlDao7J.js","_app/immutable/chunks/scheduler.CgctGpYI.js","_app/immutable/chunks/index.Dzy1rpav.js","_app/immutable/chunks/entry.Ccbg-EBq.js"];
export const stylesheets = [];
export const fonts = [];
